const steps = [      
  {
    content: 
        'In diesem kurzen Tutorial stellen wir die Grundlagen der Nutzung vom VisionLab vor.',
    placement: "center" as const,
    target: '.globalTutorialAnchor',
    title: 'Willkommen im VisionLab!'
  },
  //Step 1
  //Pause, clicking Add Pipeline triggers unpause
  {
    content: 'Als erstes erstellen wir eine neue Pipeline!',
    placement: 'right' as const,
    target: '.test5',
    hideFooter: true,
  },
  {
    content: 'In diesem Fenster können für die neue Pipeline ein Name und ein Icon ausgewählt werden. Alternativ kann auch eine bereits bestehende Pipeline kopiert werden.',
    placement: 'bottom' as const,
    target: '.pipelinedialog',
  },
  //Step 3
  //Pause, closing the Dialog triggers unpause
  {
    content: 'Um die Pipeline Erstellung abzuschließen, klicken Sie auf "Pipeline erstellen".',
    placement: 'bottom' as const,
    target: '.pipelinedialog',
    hideFooter: true,
  },
  //Step 4
  //Pause, opening the Pipeline Editor triggers unpause
  {
    content: 'Hier befinden sich alle existierenden Pipelines. Durch einen Klick auf die neu erstellte Pipeline gelangen Sie in den Pipeline Editor,',
    placement: 'right' as const,
    target: '.pipelineList-wrapper',
    hideFooter: true,
  },
  {
    content: 'In diesem Editor haben Sie die Möglichkeit Bilder auszuwählen und verschiedene Operationen wie z.B. Filter auf diese anzuwenden.',
    placement: "center" as const,
    target: '.globalTutorialAnchor',
    title: 'Willkommen im Pipeline Editor!'
  },
  {
    content: `Als erstes benötigen wir ein Startbild. Öffnen Sie dafür den Reiter "Bildquellen".`,
    placement: 'left' as const,
    target: '.camera-module',
    hideFooter: true,
  },
  //Step 7
  //Pause, uncollapsing Basic Operations triggers unpause
  {
    content: `Nun wählen Sie "Einzelbild" aus.`,
    placement: 'left' as const,
    target: '.image-service',
    hideFooter: true,
  },
  //Step 8
  //Clicking Create Service triggers unpause
  {
    content: `Geben Sie Ihrem Bild einen Namen, wählen Sie eines der voreingestellten Bilder aus und klicken Sie anschließend auf "Service erstellen".`,
    placement: 'bottom' as const,
    target: '.addServiceDialog',
    hideFooter: true,
  },
  //Step 9
  {
    content: `Als nächstes wollen wir einen Glättungsfilter auf das Bild anwenden. Öffnen Sie dafür den Reiter "Filteroperationen".`,
    placement: "left" as const,
    target: '.filter-module',
    hideFooter: true,
  },
  //Step 10
  {
    content: `Wählen Sie "Glättung" aus.`,
    placement: "left" as const,
    target: '.smooth-service',
    hideFooter: true,
  },
  //Step 11
  {
    content: `Wie zuvor, geben Sie ihrem Service einen Namen und wählen sie die benötigten Parameter aus und klicken Sie anschließend auf "Service erstellen".`,
    placement: "bottom" as const,
    target: '.addServiceDialog',
  },
  //Step 12
  {
    content: `Wenn Sie sich nicht sicher sind welche Werte Sie auswählen sollten, probieren Sie "Gaussfilter" für Filter, "7" für Filtergröße und "Konstant schwarz" für Randverhalten.`,
    placement: "bottom" as const,
    target: '.addServiceDialog',
    hideFooter: true,
  },
  //Step 13
  {
    content: `Nun haben wir zwei Services (ein Startbild und einen Filter). Diese müssen nun noch durch eine Kante miteinander verbunden werden.`,
    placement: "center" as const,
    target: '.globalTutorialAnchor',
  },
  //Step 14
  {
    content: `Klicken Sie auf "Hinzufügen"`,
    placement: "top" as const,
    target: '.add-action',
    hideFooter: true,
  },
  //Step 15
  {
    content: `Klicken Sie auf "Kante"`,
    placement: "top" as const,
    target: '.addEdge-button',
    hideFooter: true,
  },
  //Step 16
  {
    content: `Wählen Sie Start und Zielknoten in den zugehörigen Dropdown Menüs aus. Wählen Sie das Bild als Startknoten und den Glättungsservice als Zielknoten. Klicken Sie anschließen auf "Kante hinzufügen".`,
    placement: "bottom" as const,
    target: '.addEdge-dialog',
    hideFooter: true,
  },
  //Step 17
  {
    content: `Wenn Sie eine Kante oder einen Knoten entfernen möchten, wählen Sie diesen mit einem Linksklick aus, so dass die Kante bzw. der Knoten blau markiert ist. Anschließend klicken Sie in der unteren Aktionsleiste auf "Entfernen" oder drücken "Entf." auf Ihrer Tastatur. Versuchen Sie es mit der Kante, welche wir gerade erstellt haben.`,
    placement: "bottom" as const,
    target: '.PipelineEditor-paper',
    hideFooter: true,
  },
  //Step 18
  {
    content: `Nun, da wir die Kante gelöscht haben, müssen wir eine neue Kante erstellen. Ein schnellerer Weg das zu tun ist es die Shift Taste gedrückt zu halten und anschließend mit gedrückter linker Maustaste eine Kante vom Start- zum Zielknoten zu ziehen. Falls das nicht funktioniert, können Sie alternativ die vorherigen Schritte erneut ausführen.`,
    placement: "bottom" as const,
    target: '.PipelineEditor-paper',
    hideFooter: true,
  },
  //Step 19
  {
    content: `Sie sollten Ihre Pipeline regelmäßig speichern. Klicken sie dafür auf den blauen "Speichern" Knopf. Ihr aktueller Stand wird auch automatisch alle 5 Minuten gespeichert.`,
    placement: "left" as const,
    target: '.save-button',
    hideFooter: true,
  },
  //Step 20
  {
    content: `Um Ihre Pipeline auszuführen, klicken Sie auf den grünen "Ausführen" Knopf.`,
    placement: "left" as const,
    target: '.run-button',
    hideFooter: true,
  },
  //Step 21
  {
    content: `Falls alles geklappt hat, hat ihre Pipeline nun ein Ergebnis produziert. Um dieses anzuschauen klicken Sie zuerst auf den "Ergebnisse" Knopf.`,
    placement: "bottom" as const,
    target: '.navbarResults-button',
    hideFooter: true,
  },
  //Step 22
  {
    content: `In dieser Liste befinden sich alle generierten Ergebnisse Ihrer Pipelines. Neue Ergebnisse sind in gelb markiert.`,
    placement: "center" as const,
    target: '.globalTutorialAnchor',
  },
  //Step 23
  {
    content: `Um ihr Ergebnis in anzuschauen Klicken Sie zunächst auf den Namen Ihrer Pipeline.`,
    placement: "right" as const,
    target: '.resultsTable',
    hideFooter: true,
  },
  //Step 24
  {
    content: `In dieser Übersicht befinden sich alle Ergebnisse, inklusive Zwischenergebnisse, Ihrer Pipeline. In unserem Fall sind, dies nur zwei, ein Ergebnis vom Startbild und eins nachdem der Glättungsfilter angewendet wurde.`,
    placement: "center" as const,
    target: '.globalTutorialAnchor',
  },
  //Step 25
  {
    content: `Um die Bilder im Detail zu sehen, klicken Sie auf einen der Service Namen.`,
    placement: "top" as const,
    target: '.serviceTable',
    hideFooter: true,
  },
  //Step 26
  {
    content: `In dieser Übersicht, können Sie Details der einzelnen Services Ihrer Pipeline begutachten.`,
    placement: "center" as const,
    target: '.globalTutorialAnchor',
  },
   //Step 27
   {
     content: `Dieser Block zeigt Informationen über den Service, wie z.B. Name, Typ und die verwendeten Parameter.`,
     placement: "top" as const,
     target: '.results-serviceInfoList',
   },
  //Step 28
  {
    content: `In dieser Liste finden Sie alle verwendeten Services Ihrer Pipeline wieder. Um schnell zwischen den verschiedenen Services umzuschalten können Sie diese hier anklicken.`,
    placement: "left" as const,
    target: '.results-serviceQuickNavMenu',
  },
  //Step 29
  {
    content: `Sie können das Bild größer anzeigen indem Sie dieses anklicken.`,
    placement: "bottom" as const,
    target: '.result-serviceImage',
    hideFooter: true,
  },
  //Step 30
  {
    content: `Mit dem Mausrad und der linken Maustaste können Sie in das Bild rein- bzw. rauszoomen und sich die verschiedenen Teile des Bilds ansehen.`,
    placement: "center" as const,
    target: '.globalTutorialAnchor',
  },
  //Step 31
  {
    content: `Damit ist das Tutorial abgeschlossen. Sie können das Tutorial so oft wie Sie möchten wiederholen, indem Sie auf das Fragezeichen Icon in der oberen rechten Ecke klicken.`,
    placement: "center" as const,
    target: '.globalTutorialAnchor',
  },
]

export default steps;